<template>
  <div>
    <TopBar></TopBar>
    <!--  轮播图  -->
    <el-carousel :interval="2000" height="500px" max-height="540px" style="width: 100%;min-width: 1240px" >
      <el-carousel-item v-for="item in shuffle " :key="item.index" v-if="item.type =='轮播'"   >
        <img :src="item.url" alt="" style="width: 100%;height:100%;" >
      </el-carousel-item>
    </el-carousel>

    <!--  优势  -->
<!--    <el-menu class="el-menu-demo" mode="horizontal" >-->
<!--      <el-menu-item index="1" style="font-size: 18px;margin-left: 40%">优质</el-menu-item>-->
<!--      <el-menu-item index="1" style="font-size: 18px;">高效</el-menu-item>-->
<!--      <el-menu-item index="1" style="font-size: 18px;">免费</el-menu-item>-->
<!--    </el-menu>-->
    <el-main style="min-width: 1240px;margin: 0 auto;padding: 0">

      <!--      课程，点击进入课程页面-->
      <div class="bannercourse" v-for="item in shuffle " :key="item.index"  v-if="item.type =='课程'"  @click="$router.push('/courses')">
        <img :src="item.url"  alt="item.type" style="width: 100%;height:100%;" >
      </div>
      <div style="width: 100%;height: 496px;background: #FBB545;position: relative;display: none">
        <div id="class_list" >

        </div>
      </div>
      <!--      介绍页面-->
      <div class="bannercourse" v-for="item in shuffle " :key="item.index"  v-if="item.type =='介绍'"  >
        <img :src="item.url"  alt="item.type" style="width: 100%;height:100%;" @click="$router.push('/courses')">
      </div>
<!--      <img src="../../assets/image/footer.png" alt="" style="width: 100%" @click="$router.push('/courses')">-->
    </el-main>

    <!--  back top  -->
    <el-backtop :bottom="80">Top</el-backtop>

    <FootBar></FootBar>
  </div>
</template>

<script>
import TopBar from "./layout/TopBar"
import FootBar from "./layout/FootBar";
import CourseList from "./layout/CourseList";

export default {
  name: "Test",
  components: {
    TopBar,
    FootBar,
    CourseList
  },
  data() {
    return {
      shuffle: [],
      hotCourse: "",
      goodCourse: '',

    }
  },

  created() {
    this.getShuffle()
    this.getHotCourses()
    this.getHot()
  },

  methods: {
    // 获取轮播图
    async getShuffle() {
      const {data: res} = await this.$http.get("/shuffles")
      this.shuffle = res.data
      console.log(res.data)
    },
    shuffle() {
      return this.shuffle.filter(function(data) {
        console.log(data)
        //
        return data.type === '轮播'
      })
    },

    // 精选课程
    async getHotCourses() {
      const {data: res} = await this.$http.get('/courses/selected')
      this.hotCourse = res.data;

    },

    // 热门课程
    async getHot() {
      const {data: res} = await this.$http.get('/courses/hot')
      this.goodCourse = res.data;
    }
  }
};

</script>
<style lang="less" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
*{ margin:0; padding:0; }
img{display:block}
ul li{
  list-style-type:none;
}
ul{
  padding: 0 8% 0 0;
}
li{
  margin: 20px 0;
  text-align: left;
}
.imgs img {
  width: 15%;
  height: 30%;
  border-radius: 5px 5px 0 0
}
#class_list{
  width: 80%;
  margin: auto;
  display: flex;
  position: relative;
}

#class_li {
  width: 20%;
  height: 240px;
  float: left;
  margin:  100px auto;
  border-radius: 5px;
  text-align: center;
  flex: 1;
  line-height: 40px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.title{
  font-size: 22px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 20px;
}
.cont{
  font-size: 16px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 20px;
}
</style>
